var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * TagFilled icon component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconTagFilled extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.23919 1.10468C9.43803 1.08818 9.63805 1.11634 9.8246 1.1871C10.0079 1.25661 10.1735 1.36549 10.31 1.50602L22.3206 13.5166C22.6849 13.8814 22.8896 14.3758 22.8896 14.8914C22.8896 15.4069 22.6846 15.9017 22.3203 16.2665L16.2657 22.3211C15.9009 22.6854 15.4064 22.8901 14.8909 22.8901C14.3754 22.8901 13.8806 22.6851 13.5158 22.3208L1.50553 10.3105C1.36501 10.174 1.25612 10.0083 1.18661 9.82508C1.11585 9.63853 1.08769 9.43851 1.1042 9.23967C1.1057 9.22157 1.10784 9.20353 1.1106 9.18557L2.02417 3.25513C2.05194 2.93864 2.19022 2.64141 2.41557 2.41606C2.64093 2.19071 2.93816 2.05242 3.25464 2.02466L9.18509 1.11109C9.20305 1.10832 9.22108 1.10619 9.23919 1.10468ZM7.32696 8.88418C8.18652 8.88418 8.88332 8.18738 8.88332 7.32782C8.88332 6.46827 8.18652 5.77146 7.32696 5.77146C6.46741 5.77146 5.7706 6.46827 5.7706 7.32782C5.7706 8.18738 6.46741 8.88418 7.32696 8.88418Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconTagFilled.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconTagFilled.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconTagFilled.prototype, "size", void 0);
if (customElements.get('cat-icon-tag-filled') === undefined) {
    customElements.define('cat-icon-tag-filled', BlocksIconTagFilled);
}
